<body class="ltr leftmenu">
    <form autocomplete="off" novalidate [formGroup]="castIntake">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm"> 
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="col-md-8 padding">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/approval.png" class="mh-45px pb-2">
                                            <div class="">
                                                <h4 class="main-content-label mb-1"><b>
                                                        Castwise Intake
                                                    </b></h4>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Castwise Intake
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="mt-2 mb-2">
                                    <div class="row clearfix mt-3">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select required #select232 placeholder="Session"
                                                            class="colorblack" formControlName="SessionID">
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo" (click)="getCourse(item.SnNo)">
                                                                <!--  -->
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="castIntake.controls['SessionID'].touched && castIntake.controls['SessionID'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select #select55 class="colorblack"
                                                            formControlName="CoCode">
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="courseList"
                                                                (filteredReturn)="filteredCourseList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCourseList"
                                                                [value]="item.CoCgCoCode" (click)="getClg(item.CoCgCoCode)">
                                                                <!-- (click)="getClg(item.CoCgCoCode)" -->
                                                                {{item.CoCgCoCode}} - {{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                        *ngIf="castIntake.controls['CoCode'].touched && castIntake.controls['CoCode'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="CgCode"
                                                            formControlName="CgCode" [displayMember]="'CgName'">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredCollegeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCollegeList"
                                                                [value]="item.CoCgCgCode" (click)="getCount(item.CoCgCgCode,item)">
                                                                {{item.CoCgCgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                        *ngIf="castIntake.controls['CgCode'].touched && castIntake.controls['CgCode'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="showCount" class="col-sm-3 mt-3">
                                      Total Intake : {{inteckCount}}
                                        </div>
                                    </div>
                                    <div *ngIf='istableShow' class="table-responsive table-container mt-3">
                                        <table  class="table table-bordered text-left">
                                            <thead>
                                                <tr>
                                                    <th class="f600 ">
                                                        Cast Name </th>
                                                    <th class="f600 text-center">
                                                        Recognized Intake </th>
                                                    <th class="f600 text-center">
                                                        Permitted Intake </th>
                                                        <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody  formArrayName="CollegeCastArr">
                                                <tr *ngFor="let cast of getControls();let last = last; let i = index"
                                                    [formGroupName]="i">
                                                    <td >
                                                        <mat-form-field appearance="outline"
                                                        class="example-full-width ">
                                                        <mat-label>
                                                            Cast
                                                        </mat-label>
                                                        <mat-select #select25 placeholder=""
                                                            formControlName="Caste" required>
                                                            <mat-select-filter *ngIf="select25.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="categoryList"
                                                                (filteredReturn)="filteredCategoryList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCategoryList"
                                                                [value]="item.CdCode" (click)="duplicateCheck(item,i)">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    <mat-error class="margin_tp mrgtp"
                                                    *ngIf="cast.controls.Caste.touched && cast.controls.Caste.errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                    </mat-form-field>
                                                   
                                                    </td>
                                                    <td>
                                                        <input class="form-control text-center"
                                                                formControlName="RecongnizedIntake" maxlength="4" required>
                                                           
                                                        <mat-error class="margin_tp mrgtp"
                                                    *ngIf="cast.controls.RecongnizedIntake.touched && cast.controls.RecongnizedIntake.errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                    </td>
                                                    <td>
                                                        <input class="form-control text-center" (input)="onInputChange($event,i)"
                                                            formControlName="PermittedIntake" maxlength="4" required>
                                                           
                                                        <mat-error class="margin_tp mrgtp"
                                                    *ngIf="cast.controls.PermittedIntake.touched && cast.controls.PermittedIntake.errors?.required">
                                                    Mandatory
                                                </mat-error>
                                                    </td>
                                                    <td class="text-center">
                                                        <a *ngIf="last" class="btn-floating" title="AddNew">
                                                            <i class="fa fa-plus" (click)="addNewRow2(i,cast);"></i>
                                                        </a>
                                                        <a *ngIf="last" class="btn-floating" title="Remove">
                                                            <i class="fa fa-minus" (click)="deleteRow(i)"></i></a>
                                                        
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div  *ngIf='istableShow' class="col-sm-12 mt-2">

                                        <label> <span class="Text">Total Count :</span>{{getTotalCount()}} </label>
    
                                    </div>
                                    <div class="col mt-2" *ngIf="showErr">
                                        {{Message}}
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-12 prpl">
                                            <button  type="button" *ngIf="submitButton && castCreate" [disabled]="buttonDisabled"
                                                class="btn btn-primary btn-icon-text floatright mt-1 fr" (click)="save()" >
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                                    Save
                                                </span>
                                            </button>
                                            <button  type="button" *ngIf="updateButton && castUpdate" [disabled]="buttonDisabled"
                                                class="btn btn-primary btn-icon-text floatright mt-1 fr" (click)="update()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                                    Update
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
</body>